import request from "@/utils/request";
export var getLibraryProductPage = function getLibraryProductPage(data) {
  return request({
    url: process.env.VUE_APP_API_PREFIX + "/outParcelBill/getLibraryProductPage",
    method: "post",
    data: data
  });
};
export var getOutlibraryStateNumVo = function getOutlibraryStateNumVo(params) {
  return request({
    url: process.env.VUE_APP_API_PREFIX + "/outParcelBill/getOutlibraryStateNumVo",
    method: "get",
    params: params
  });
};
export var getOutDeliverBillDetail = function getOutDeliverBillDetail(data) {
  return request({
    url: process.env.VUE_APP_API_PREFIX + "/out/deliver/getOutDeliverBillDetail",
    method: "post",
    data: data
  });
};
//取消发货单
export var adjustCancelDeliver = function adjustCancelDeliver(data) {
  return request({
    url: process.env.VUE_APP_API_PREFIX + "/out/deliver/wms/adjustCancelDeliver",
    method: "post",
    data: data
  });
};
//查询发货通知单SKU
export var queryDeliverSku = function queryDeliverSku(data) {
  return request({
    url: process.env.VUE_APP_API_PREFIX + "/out/deliver/wms/queryDeliverSku",
    method: "post",
    data: data
  });
};
//删除发货通知单SKU
export var deleteDeliverSku = function deleteDeliverSku(data) {
  return request({
    url: process.env.VUE_APP_API_PREFIX + "/out/deliver/wms/deleteDeliverSku",
    method: "post",
    data: data
  });
};
// 导出待发货数据
export var exportDeliverData = function exportDeliverData(data) {
  return request({
    url: process.env.VUE_APP_API_PREFIX + "/out/deliver/exportDeliverData",
    method: "POST",
    data: data,
    responseType: "arraybuffer"
  });
};
// 优先生成包裹
export var priorityPackageGeneration = function priorityPackageGeneration(data) {
  return request({
    url: process.env.VUE_APP_API_PREFIX + "/out/deliver/priorityPackageGeneration",
    method: "POST",
    data: data
  });
};